import { WatchQueryFetchPolicy, useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'

import { HasVisualAssortmentAccessDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { isLiteRetailer as isLiteRetailerSelector } from 'store/currentUser/selectors'

interface UseHasVAAccessOptions {
  fetchPolicy?: WatchQueryFetchPolicy
}

export const useHasVAAccess = ({
  fetchPolicy = 'cache-first',
}: UseHasVAAccessOptions = {}) => {
  const isLiteRetailer = useSelector(isLiteRetailerSelector)
  const { data, loading, error, refetch } = useQuery(
    HasVisualAssortmentAccessDocument,
    {
      client: atlasClient,
      fetchPolicy,
      skip: !isLiteRetailer,
    },
  )

  const hasAccountAccess = Boolean(
    data?.hasVisualAssortmentAccess?.hasAccountAccess,
  )
  const hasUserAccess = Boolean(data?.hasVisualAssortmentAccess?.hasUserAccess)

  return {
    hasVAAccess: hasAccountAccess && hasUserAccess,
    hasAccountAccess,
    hasUserAccess,
    isAccessInitialized: Boolean(
      data?.hasVisualAssortmentAccess?.isAccessInitialized,
    ),
    loading,
    error,
    refetch,
  }
}
